import { GoogleGenAI } from "@google/genai";
import { OPENAI_KEY } from "./constants";

const openai = new GoogleGenAI({
  apiKey: OPENAI_KEY, // This is the default and can be omitted
  dangerouslyAllowBrowser: true,
});

export default openai;
